import { AuthService } from './../../../shared/services/auth.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() collapsed = new EventEmitter();
  @Output() search = new EventEmitter();
  @Output() close = new EventEmitter();
  _authService;
  constructor(private authService: AuthService) {
    this._authService = authService;
  }

  ngOnInit(): void {
  }

  collapse() {
    this.collapsed.emit();
  }

  showSearch() {
    this.search.emit();
  }

  closeSearch() {
    this.close.emit();
  }
}
